export default __webpack_public_path__ + "static/media/beincrypto_logo.7f0ef278.svg";